<form [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <h4>Additional Supplements</h4>
    <digital-platform-file-upload
      data-cy="Additional-Supl-Upload-Btn"
      class="Additional"
      fxFlex="500px"
      formControlName="attachment"
      (fileDeleted)="onFileDelete($event)"
    ></digital-platform-file-upload>
  </div>
  <div fxLayout="row" *ngIf="form.value.attachment">
    <div class="input-container size-half">
      <label> Comments (Optional) </label>
      <mat-form-field appearance="outline">
        <textarea
          maxlength="48"
          formControlName="comments"
          matInput
          matTextareaAutosize
          matAutosizeMinRows="4"
          matAutosizeMaxRows="4"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
